// const userName = " " + sessionStorage.getItem("SessionName") || "";
const userNameToModify = sessionStorage.getItem("SessionName") ? " " + sessionStorage.getItem("SessionName") : "";
var shortenedAddressWithFilters = "";

if (document.documentElement.lang == "de") {
  var baseUrl = "/de/collections/quiz?";
} else if (document.documentElement.lang == "pl") {
  var baseUrl = "/pl/collections/quiz?";
} else if (document.documentElement.lang == "fr") {
  var baseUrl = "/fr/collections/quiz?";
} else {
  var baseUrl = "/collections/quiz?";
}

function titleCase(str) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
}

const userName = titleCase(userNameToModify);

(function () {
  const questionsQuiz = [
    /*
    stepId: 1 ======================================= 
    answerType: tile/header
    reaction: false
    */
    {
      question: "Sure we will! It turned out that you have the rest of the day off. What would you do?",
      reaction: "",
      answersType: "tile",
      stepId: 1,
      choices: [
        {
          header: "Home",
          name: "I would indulge myself in relaxation at home: reading, netflixing, sleeping.",
          tags: ["Home"],
          stepId: 1.1,
          checked: false,
        },
        {
          header: "Out in nature",
          name: "I would definitely be out in nature walking, doing sports or spending time in a park.",
          tags: ["Nature,outside"],
          stepId: 1.1,
          checked: false,
        },
        {
          header: "Fitness",
          name: "I would improve my fitness by going to the gym, doing yoga, cycling or other type of sports",
          tags: ["Fitness"],
          stepId: 1.1,
          checked: false,
        },
        {
          header: "Hanging out",
          name: "I would definitely hang out with my friends. At home or out - doesn't matter.",
          tags: ["Hanging Out"],
          stepId: 1.1,
          checked: false,
        },
      ],
    },
    /*
    stepId: 1.1 ======================================= 
    answerType: radio
    reaction: true
    */
    {
      question: "How would you describe your relationship with colors?",
      reaction: "Oh, lovely!",
      reactionImg: "https://cdn.shopify.com/s/files/1/0254/3963/3488/files/lovely.svg?v=1661931296",
      answersType: "radio",
      stepId: 1.1,
      choices: [
        {
          name: "Monochrome only",
          tags: ["Beige,Black,Light Grey,Oak,Walnut,Blue"],
          stepId: 1.2,
          checked: false,
        },
        {
          name: "A little splash of color never hurt anyone",
          tags: ["Beige,Black,Blue,Burgundy,Green,Light Grey,Oak,Orange,Terracotta,Walnut,Yellow,Pink,Red,Violet"],
          stepId: 1.2,
          checked: false,
        },
        {
          name: "Color, color, color. Repeat.",
          tags: ["Blue,Burgundy,Green,Orange,Terracotta,Yellow,Beige,Pink,Red,Violet"],
          stepId: 1.2,
          checked: false,
        },
        {
          name: "All I need is earth colors.",
          tags: ["Beige,Black,Burgundy,Light Grey,Oak,Terracotta,Walnut"],
          stepId: 1.2,
          checked: false,
        },
      ],
    },
    /*
    stepId: 1.2 ======================================= 
    answerType: radio
    reaction: true
    */
    {
      question: "What kind of textures do you like most?",
      reaction: "Well noted.",
      reactionImg: "https://cdn.shopify.com/s/files/1/0254/3963/3488/files/OK.svg?v=1661931297",
      answersType: "tile",
      stepId: 1.2,
      choices: [
        {
          header: "Soft & warm",
          name: "I like things to be soft and warm to touch (veneers, fabrics).",
          tags: ["Wooden,Upholstery,Textile"],
          stepId: 1.3,
          checked: false,
        },
        {
          header: "Raw & clean",
          name: "I enjoy raw and clean surfaces (steel, board, glass)",
          tags: ["Board,Metal,Wooden"],
          stepId: 1.3,
          checked: false,
        },
        {
          header: "Structured",
          name: "Irregular, structured materials are my thing (veneer, steel, fabrics)",
          tags: ["Upholstery,Metal,Wooden,Textile"],
          stepId: 1.3,
          checked: false,
        },
        {
          header: "Mix & match",
          name: "Why limit yourself? Let’s mix it all!",
          tags: ["Upholstery,Metal,Wooden,Board,Textile"],
          stepId: 1.3,
          checked: false,
        },
      ],
    },
    /*
    stepId: 1.3 ======================================= 
    answerType: tile/header
    reaction: true
    */
    {
      question: "How would you describe your dream environment?",
      reaction: userName ? "Good to know, " + userName : "Good to know.",
      reactionImg: "https://cdn.shopify.com/s/files/1/0254/3963/3488/files/OK.svg?v=1661931297",
      answersType: "tile",
      stepId: 1.3,
      choices: [
        {
          header: "Cottage",
          name: "Small cottage in the middle of nowhere",
          tags: ["Cottage,Textile,Wooden"],
          stepId: 1.4,
          checked: false,
        },
        {
          header: "City",
          name: "Modern apartment in the vibrant city",
          tags: ["City,Metal,Board"],
          stepId: 1.4,
          checked: false,
        },
        {
          header: "Air & Light",
          name: "Anything with big windows and high ceilings",
          tags: ["Air and Light,Metal,Board"],
          stepId: 1.4,
          checked: false,
        },
        {
          header: "Cosy",
          name: "Simple house/ apartment for a family of 4+",
          tags: ["Cosy,Textile,Upholstery,Wooden"],
          stepId: 1.4,
          checked: false,
        },
        {
          header: "Wow",
          name: "George Clooney's Como Lake villa",
          tags: ["Wow,Upholstery,Metal"],
          stepId: 1.4,
          checked: false,
        },
      ],
    },
    /*
    stepId: 1.4 ======================================= 
    answerType: radio
    reaction: true
    */
    {
      question: "How much are you willing to spend?",
      reaction: `<span>Cool. Now, let's talk about money. <br> <span style="font-size:30px">🎵 Money, money, money... 🎵</span></span>`,
      reactionImg: "https://cdn.shopify.com/s/files/1/0254/3963/3488/files/money.svg?v=1661931296",
      answersType: "radio",
      stepId: 1.4,
      choices: [
        {
          name: "Up to €500",
          tags: ["price_<50,price_50-100,price_100-200,price_200-300,price_300-500"],
          // tags: ["gte=0,lte=500"],
          stepId: false,
          checked: false,
        },
        {
          name: "€500-€1000",
          tags: ["price_500-1000"],
          // tags: ["gte=500,lte=1000"],
          stepId: false,
          checked: false,
        },

        {
          name: "More than €1000",
         tags: ["price_>1000"],
          // tags: ["gte=2500,lte=999999"],
          stepId: false,
          checked: false,
        },
      ],
    },
  ];

  let currentQuestionId = 1; //Tracks the question number
  const selections = []; //Array containing user choices
  let prevSelect; // Last user's step pick
  let idIncrementer = 1; //Id for DOM question input for data-step
  let progressCounter = 1;

  // Basic quiz steps length (could change after specific room pick)
  let finSteps = 6;

  const quiz = document.querySelector("#quiz");
  const nextBtn = document.querySelector(".next-question-btn");
  const prevBtn = document.querySelector(".prev-question-btn");
  const quizResultsBtn = document.querySelector('[data-name="quiz-results-btn"]');
  const progressBar = document.querySelector(".quiz-progress-bar");
  const errorDiv = document.querySelector(".quiz-error-msg");
  const newsletterSection = document.querySelector(".Quiz-footer__Newsletter");
  const quizLoader = document.querySelector(".Quiz-loader");
  const quizWrapper = document.querySelector(".quiz-wrapper");

  // Go to the next question, when click button
  function nextBtnAction() {
    const answer = document.querySelector('input[name="answer"]:checked');
    const answerCheckboxes = document.querySelectorAll('input[type="checkbox"][name="answer"]:checked');

    // Block a multiple clicks
    nextBtn.style.pointerEvents = "none";
    setTimeout(() => {
      nextBtn.style.pointerEvents = "auto";
    }, 400);

    if (!answer) {
      errorDiv.innerHTML = `<div class="error-alert"><div class="icon-wrap"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5402 6.87885H7.31795M13.5402 10.4344H9.09573M7.05129 15.4122L1.98462 17.1011L3.67351 12.0344C3.67351 12.0344 2.87351 10.8789 2.87351 8.65663C2.87351 4.48381 6.25626 1.10107 10.4291 1.10107C14.6019 1.10107 17.9846 4.48381 17.9846 8.65663C17.9846 12.8294 14.6019 16.2122 10.4291 16.2122C8.13155 16.2122 7.05129 15.4122 7.05129 15.4122Z" stroke="#C9553E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div><p>Ups, the answer is missing. Take another look to go further.</p></div>`;
      return;
    }

    if (answerCheckboxes.length != 0 && answerCheckboxes.length < 3) {
      errorDiv.innerHTML = `<div class="error-alert warn"><div class="icon-wrap"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5402 6.87885H7.31795M13.5402 10.4344H9.09573M7.05129 15.4122L1.98462 17.1011L3.67351 12.0344C3.67351 12.0344 2.87351 10.8789 2.87351 8.65663C2.87351 4.48381 6.25626 1.10107 10.4291 1.10107C14.6019 1.10107 17.9846 4.48381 17.9846 8.65663C17.9846 12.8294 14.6019 16.2122 10.4291 16.2122C8.13155 16.2122 7.05129 15.4122 7.05129 15.4122Z" stroke="#C9553E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div><p>Psst, please select at least 3 answers to find a better match.</p></div>`;
      return;
    }

    if (progressCounter < finSteps - 1) {
      errorDiv.innerHTML = "";
      choose();
      progressCounter++;

      moveProgressBar();
    } else {
      // If a user finished the quiz
      choose();
      progressCounter++;

      moveProgressBar();
      renderFinalScreen();
    }
  }
  nextBtn.addEventListener("click", nextBtnAction);

  // Go to the previous question, when click button
  function prevBtnAction() {
    // Block a multiple clicks
    prevBtn.style.pointerEvents = "none";
    setTimeout(() => {
      prevBtn.style.pointerEvents = "auto";
    }, 400);

    if (progressCounter > 1) {
      back();
      progressCounter--;

      moveProgressBar();
    } else {
      return;
    }
  }
  prevBtn.addEventListener("click", prevBtnAction);

  // Next BtnAction on the radio input click
  function nextQuestionOnRadioBtn(e) {
    // Block a multiple clicks
    const quizListContainerToBlock = document.querySelector(".quiz-q-list");
    quizListContainerToBlock.style.pointerEvents = "none";
    setTimeout(() => {
      quizListContainerToBlock.style.pointerEvents = "auto";
    }, 400);

    if (e.target.classList.contains("radio-input") || e.target.classList.contains("till-input")) nextBtnAction();
  }

  // Dispaly initial progress
  moveProgressBar();
  // Display initial question
  displayNext();

  // Creates and returns the div that contains the questionsQuiz and the answer selections
  function createQuestionElement(index, step) {
    var qElement = document.createElement("div");
    var qHeader = document.createElement("h2");
    qElement.setAttribute("data-id", idIncrementer);
    qElement.classList.add("quiz-question", "new-quiz-question");
    qHeader.classList.add("quiz-question__header", "new-quiz-question");

    questionsQuiz.forEach((question) => {
      if (question.stepId == step) {
        qElement.append(qHeader);
        qElement.setAttribute("data-step", question.stepId);
        qHeader.append(question.question);
      }
    });

    var radioButtons = createRadios(index, step);
    qElement.append(radioButtons);
    idIncrementer++;
    return qElement;
  }

  // Creates a list of the answer choices as radio inputs
  function createRadios(index, step) {
    var elementsList = document.createElement("ul");
    var item;
    var input = "";
    questionsQuiz.forEach((question) => {
      // If classic radio buttons
      if (question.stepId == step && question.answersType === "radio") {
        elementsList.classList.add("quiz-q-list");

        for (let i = 0; i < question.choices.length; i++) {
          item = document.createElement("li");
          item.classList.add("quiz-q-li");
          input = document.createElement("input");
          label = document.createElement("label");
          label.setAttribute("for", question.choices[i].tags + "-identificator");
          label.textContent = question.choices[i].name;
          input.classList.add("radio-input");
          label.classList.add("label-classic");
          input.setAttribute("type", "radio");
          input.setAttribute("name", "answer");
          input.setAttribute("id", question.choices[i].tags + "-identificator");
          input.setAttribute("value", question.choices[i].tags);
          input.setAttribute("data-step", question.choices[i].stepId);
          item.append(input, label);
          elementsList.append(item);

          if (question.choices[i].checked && input.value == question.choices[i].tags) {
            input.checked = true;
          } else {
            input.checked = false;
            question.choices[i].checked = false;
          }
        }

        // If classic checkboxes
      } else if (question.stepId == step && question.answersType === "checkbox") {
        elementsList.classList.add("quiz-q-list");

        for (let i = 0; i < question.choices.length; i++) {
          item = document.createElement("li");
          item.classList.add("quiz-q-li");
          input = document.createElement("input");
          label = document.createElement("label");
          label.setAttribute("for", question.choices[i].tags + "-identificator");
          label.textContent = question.choices[i].name;
          input.classList.add("checkbox-input");
          label.classList.add("label-classic");
          label.classList.add("label-classic--checkbox");
          input.setAttribute("type", "checkbox");
          input.setAttribute("name", "answer");
          input.setAttribute("id", question.choices[i].tags + "-identificator");
          input.setAttribute("value", question.choices[i].tags);
          input.setAttribute("data-step", question.choices[i].stepId);
          item.append(input, label);
          elementsList.append(item);

          if (question.choices[i].checked && input.value == question.choices[i].tags) {
            input.checked = true;
          } else {
            input.checked = false;
            question.choices[i].checked = false;
          }
        }

        // If stylized radio buttons
      } else if (question.stepId == step && question.answersType === "tile") {
        for (let i = 0; i < question.choices.length; i++) {
          if (question.choices[i].image) {
            elementsList.classList.add("quiz-q-list", "quiz-q-list--tiller-img");
          } else {
            elementsList.classList.add("quiz-q-list", "quiz-q-list--tiller");
          }

          item = document.createElement("li");
          header = document.createElement("h3");
          paragraph = document.createElement("p");
          header.textContent = question.choices[i].header;
          paragraph.textContent = question.choices[i].name;
          input = document.createElement("input");
          label = document.createElement("label");
          label.setAttribute("for", question.choices[i].tags + "-identificator");
          input.classList.add("till-input");
          label.classList.add("label-till");
          header.classList.add("label-till__header");
          paragraph.classList.add("label-till__paragraph");
          input.setAttribute("type", "radio");
          input.setAttribute("name", "answer");
          input.setAttribute("id", question.choices[i].tags + "-identificator");
          input.setAttribute("value", question.choices[i].tags);
          input.setAttribute("data-step", question.choices[i].stepId);

          // Add graphic for the input with svg
          if (question.choices[i].image) {
            // image = document.createElement("img");
            // image.src = question.choices[i].image;
            item.classList.add("till-li");
            image = document.createElement("div");
            image.classList.add("svg-till-wrapper");
            image.innerHTML = question.choices[i].image;
            label.classList.add("label-till--img");
            label.prepend(image, header, paragraph);

            if (question.choices.length < 4) {
              item.classList.add("till-li-33");
            } else {
              item.classList.add("till-li-25");
            }
          } else {
            label.prepend(header, paragraph);
          }

          item.append(input, label);
          elementsList.append(item);

          if (question.choices[i].checked && input.value == question.choices[i].tags) {
            input.checked = true;
          } else {
            input.checked = false;
            question.choices[i].checked = false;
          }
        }
      }
    });
    return elementsList;
  }

  // Reads the user selection and pushes the value to an array
  function choose() {
    const answer = document.querySelector('input[name="answer"]:checked');
    const questionInDom = document.querySelector(".quiz-question");
    const quizInputs = document.querySelectorAll('input[name="answer"]');
    currentQuestionId = answer.getAttribute("data-step");
    // selections.push(currentQuestionId);

    // Setup the progress bar
    // if (answer.value == "") {
    //   finSteps = ;
    // } else if (answer.value == "") {
    //   finSteps = ;
    // }

    //! POPRAWKA
    // Push only selected tags to the tags array and update checked status for objects
    quizInputs.forEach((checkbox) => {
      if (checkbox.checked) {
        questionsQuiz.forEach((question) => {
          if (question.stepId == questionInDom.getAttribute("data-step")) {
            question.choices.forEach((choice) => {
              if (!choice.checked && choice.tags == checkbox.value) {
                choice.checked = true;
              } else if (choice.checked && question.answersType == "radio") {
                choice.checked = false;
              }
            });
          }
        });
      } else if (!checkbox.checked && checkbox.type == "checkbox") {
        questionsQuiz.forEach((question) => {
          if (question.stepId == questionInDom.getAttribute("data-step")) {
            question.choices.forEach((choice) => {
              if (choice.checked && choice.tags == checkbox.value) {
                choice.checked = false;
              }
            });
          }
        });
      }
    });

    selections.push(questionInDom.getAttribute("data-step"));

    setTimeout(function () {
      const questionToRemove = document.querySelectorAll(".new-quiz-question");
      questionToRemove.forEach((question) => {
        if (question.stepId != currentQuestionId) {
          question.remove();
        }
      });
    }, 400);

    displayNext();
  }

  // Test for previous step btn
  function back() {
    if (selections.length <= 1) {
      questionsQuiz.forEach((question) => {
        question.choices.forEach((choice) => {
          choice.checked = false;
        });
      });
    }
    if (selections.length > 0) {
      prevSelect = selections.pop();
      currentQuestionId = prevSelect;
    } else {
      currentQuestionId = 1;
    }

    // Compare and remove duplicate tags
    let compareArr = [];
    const quizInputs = document.querySelectorAll('input[name="answer"]');
    quizInputs.forEach((checkbox) => {
      compareArr = compareArr.concat(checkbox.value.split(","));
    });

    setTimeout(function () {
      const questionToRemove = document.querySelectorAll(".new-quiz-question");
      questionToRemove.forEach((question) => {
        questionsQuiz.forEach((q) => {
          if (q.stepId == question.getAttribute("data-step")) {
            q.choices.forEach((choice) => {
              choice.checked = false;
            });
          }
        });
        question.remove();
      });
    }, 400);
    displayNext();
  }

  // Scroll your view to the top
  function backToTop() {
    document.querySelector(".btn--to-top").click();
  }

  // Displays next requested element with animation
  function displayNext() {
    id = 0;
    var nextQuestion = createQuestionElement(id, currentQuestionId);

    questionsQuiz.forEach((question) => {
      if (question.stepId == currentQuestionId && question.reaction) {
        const reactionDiv = document.querySelector(".quiz-reaction-wrapper");
        const reactionImg = document.querySelector(".reaction-img");
        const reactionHeader = document.querySelector(".reaction-header");
        const quizWrapper = document.querySelector("#quiz");

        reactionImg.src = question.reactionImg;
        reactionHeader.innerHTML = question.reaction;
        reactionDiv.style.opacity = 1;
        reactionImg.style.opacity = 1;
        quizWrapper.style.opacity = 0;
        reactionDiv.style.height = "100%";

        setTimeout(function () {
          reactionImg.style.opacity = 0;
          reactionDiv.style.opacity = 0;
          reactionDiv.style.height = 0;
          quizWrapper.style.opacity = 1;
          reactionHeader.textContent = "";
          reactionImg.src = "";
          question.reaction = "";
          // }, 1500);
        }, 1100);
      } else {
        setTimeout(function () {
          quiz.append(nextQuestion);
          // }, 500);
        }, 800);
      }
    });

    // Get the quiz container variable and store it
    setTimeout(function () {
      const quizListContainer = document.querySelector(".quiz-q-list");
      //! POPRAWKA
      if (quizListContainer) {
        quizListContainer.addEventListener("click", nextQuestionOnRadioBtn);
      }
    }, 800);
  }

  // Count progress and update the progress bar
  function moveProgressBar() {
    let currentProgress = (progressCounter / finSteps) * 100;
    progressBar.style.width = currentProgress + "%";
  }

  // Render the final screen with newsletter, generate the final url address and see results buttons
  function renderFinalScreen() {
    const resultTagsArr = [];
    questionsQuiz.forEach((question) => {
      question.choices.forEach((choice) => {
        if (choice.checked) {
          resultTagsArr.push(choice.tags);
        }
      });
    });
    const resultTagsFlatt = resultTagsArr.flat(1);
    const resultTagsString = resultTagsFlatt.join(",");
    const finalTagsArr = resultTagsString.split(",");

    const roomMetaFilter = ["Bathroom", "Bedroom", "Dining Room", "Hallway", "Home Office", "Living Room"];
    const typeMetaFilter = [
      "Armchairs",
      "Beds",
      "Bundles",
      "Cabinets",
      "Chairs",
      "Coffee Tables",
      "Consoles",
      "Ladders",
      "Nightstands",
      "Poufs",
      "Seatings",
      "Shelves",
      "Shelving Units",
      "Sideboards",
      "Sofas",
      "Stools",
      "TV Stands",
      "Tables",
      "Side Tables",
      "Tableware",
      "Bookends",
      "Candle Holders",
      "Ladders",
      "Lamps",
      "Mirrors",
      "Plant Pots",
      "Umbrella Stands",
    ];
    const colorMetaFilter = [
      "Beige",
      "Black",
      "Blue",
      "Burgundy",
      "Green",
      "Light Grey",
      "Oak",
      "Orange",
      "Terracotta",
      "Walnut",
      "Yellow",
      "Pink",
      "Red",
      "Violet",
    ];
    const priceMetaFilter = ["price_<50", "price_50-100", "price_100-200", "price_200-300", "price_300-500", "price_500-1000", "price_>1000" ];
    // const priceMetaFilter = ["gte=0", "gte=100", "gte=250", "gte=500", "gte=1000", "gte=2500", "gte=5000", "gte=100", "lte=100", "lte=250", "lte=500", "lte=1000", "lte=2500", "lte=999999"];
    const widthMetaFilter = ["30-50 cm", "50-70 cm", "70-120 cm", "120-160 cm", "170-200 cm", ">200 cm", "1-30 cm"];
    const materialMetaFilter = ["Board", "Metal", "Upholstery", "Wooden", "Textile"];
    const quizMetaFilter = [
      "Kids room",
      "1 Person",
      "2 Person",
      "3-6 People",
      ">6 People",
      "Desks",
      "Bar carts",
      // ">5000€",
      "Benches",
      "Shelving Units 2-tier",
      "Shelving Units 3-tier",
      "Shelving Units 4-tier",
      "Shelving Units 5-tier",
      "Glass",
      "Usefulness",
      "Beauty",
      "Exceptionality",
      "Good value for money",
      "kid",
      "ho",
      "outside",
    ];

    let roomFilters = "&";
    let typeFilters = "&";
    let colorFilters = "&";
    let priceFilters = "&";
    let widthFilters = "&";
    let materialFilters = "&";
    let quizFilters = "&";

    finalTagsArr.some((el) => {
      if (roomMetaFilter.indexOf(el) >= 0) {
        roomFilters += `filter.p.m.custom.product_page_room=${el}&`;
      }
      if (typeMetaFilter.indexOf(el) >= 0) {
        typeFilters += `filter.p.m.my_fields.type2=${el}&`;
      }
      if (colorMetaFilter.indexOf(el) >= 0) {
        colorFilters += `filter.p.m.custom.product_page_color=${el}&`;
      }
      if (priceMetaFilter.indexOf(el) >= 0) {
        priceFilters += `filter.v.price.${el}&`;
        // priceFilters += `filter.p.m.my_fields.price=${el}&`;
      }
      if (widthMetaFilter.indexOf(el) >= 0) {
        widthFilters += `filter.p.m.custom.product_page_width=${el}&`;
      }
      if (materialMetaFilter.indexOf(el) >= 0) {
        materialFilters += `filter.p.m.custom.product_page_material_filters=${el}&`;
      }
      if (quizMetaFilter.indexOf(el) >= 0) {
        quizFilters += `filter.p.m.custom.quiz=${el}&`;
      }
    });

    const finalUrl = baseUrl + roomFilters + typeFilters + colorFilters + priceFilters + widthFilters + materialFilters + quizFilters + "?userName=" + userName;

    async function shortUrl() {
      function extractShortURL(jsonData) {
        const regex = /"short_url":\s*"([^"]+)"/;
        const match = jsonData.match(regex);
        return match && match.length > 1 ? match[1] : "Short URL not found";
      }

      var myHeaders = new Headers();
      myHeaders.append("apikey", "mlYcqewNYmx6Sy5TLHHxPJd4hglinLKl");
      console.log(`Final URL: ${finalUrl}`);
      var raw = `https://noo.ma${finalUrl}`;

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
      };

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds timeout

      try {
        console.log('start fetching');
        const response = await fetch("https://api.apilayer.com/short_url/hash", {
          ...requestOptions,
          signal: controller.signal
        });
        clearTimeout(timeoutId);

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const result = await response.text();
        shortenedAddressWithFilters = extractShortURL(result);
        console.log("Shortened URL:", shortenedAddressWithFilters);
        return shortenedAddressWithFilters;

      } catch (error) {
        console.log("Error:", error);
        shortenedAddressWithFilters = "Error generating short URL";
        return shortenedAddressWithFilters;
      }
    }

    setTimeout(function () {
      newsletterSection.classList.remove("hidden-section-quiz");
      quizWrapper.classList.add("hidden-section-quiz");
    }, 800);

    async function goToResultPage() {
      // const userEmail = document.querySelector("#email_128622912");
      const userEmail = document.querySelector('input[type="email"][name="email"]');
      const formTemplateName = document.querySelector('[data-name="analyticFormName"]');
      const formTemplateEmail = document.querySelector('[data-name="analyticFormEmail"]');
      const formTemplateTime = document.querySelector('[data-name="analyticFormTime"]');
      const formTemplateUrl = document.querySelector('[data-name="analyticFormUrl"]');
      const currentDate = new Date();

      document.querySelector(".user-name-heading").textContent = userName;
      newsletterSection.classList.add("hidden-section-quiz");
      quizLoader.classList.remove("hidden-section-quiz");
      await shortUrl();
      console.log(shortenedAddressWithFilters);

      // Data analytics
      const formTemplate = document.querySelector('[data-name="analyticForm"]');
      const formDataBtn = formTemplate.querySelector("button");
      const containerAnswers = document.querySelectorAll(".FormDiv input");

      questionsQuiz.forEach((question) => {
        question.choices.forEach((choice) => {
          containerAnswers.forEach((answer) => {
            if (
              (answer.classList.value == question.stepId &&
                choice.name.toLowerCase() == answer.value.toLowerCase() &&
                choice.checked) ||
              (answer.classList.value == question.stepId && choice.header == answer.value && choice.checked)
            ) {
              if (!answer.checked) {
                answer.checked = true;
              }
            }
          });
        });
      });

      const datetime = "Timestamp: " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear() + " @ " + currentDate.getHours() + ":" + currentDate.getMinutes() + ":" + currentDate.getSeconds();
      formTemplateName.value = userNameToModify;
      formTemplateEmail.value = userEmail.value;
      formTemplateTime.value = datetime;
      formTemplateUrl.value = shortenedAddressWithFilters;
      formDataBtn.click();

      setTimeout(() => {
        window.location.href = shortenedAddressWithFilters;
      }, 2500);
    }

    window.addEventListener("klaviyoForms", function (e) {
      if (e.detail.type == 'submit') {
        console.log('submit it');
        goToResultPage();
      }
    });
    quizResultsBtn.addEventListener("click", goToResultPage);
  }
})();

window.onload = function () {
  questionsQuiz.forEach((question) => {
    question.choices.forEach((choice) => {
      choice.checked = false;
    });
  });
};